import { atom } from "jotai";

export const informacionPlataformaAtom = atom(undefined);
export const visibleVerificarIdentidadPageAtom = atom(true);
export const visibleCrearClavePageAtom = atom(false);
export const numeroDocumentoIdentidadAtom = atom("");
